import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { ButtonBase, Stack } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { Link } from "react-router-dom";

/** Styles shared by the stats with and without a link */
const STAT_SX = {
  flex: 1,
  minWidth: 0,
  maxWidth: {
    sm: "24rem"
  },
  // A lone stat spans the whole summary
  "&:only-child": {
    maxWidth: "none"
  },
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 2,
  p: 2,
  textAlign: "left",
  borderRadius: 1,
  backgroundColor: "surfaces.secondary"
};
/** Amount of markups with an icon, linking to them in the annotations tab if possible */
export function MarkupsSummaryStat(t0) {
  const $ = _c(22);
  const {
    icon,
    count,
    label,
    link
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "3rem",
      height: "3rem",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      color: "primary.main",
      backgroundColor: "background.paper"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== icon) {
    t2 = <Stack sx={t1}>{icon}</Stack>;
    $[1] = icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minWidth: 0
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== count) {
    t4 = <Text variant="heading32"><var>{count}</var></Text>;
    $[4] = count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "text.secondary"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = <Text variant="bodyM" sx={t5}>{label}</Text>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <Stack sx={t3}>{t4}{t6}</Stack>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const content = t8;
  if (!link) {
    let t9;
    if ($[15] !== content) {
      t9 = <Stack direction="row" sx={STAT_SX}>{content}</Stack>;
      $[15] = content;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    return t9;
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      ...STAT_SX,
      transition: "background-color 150ms",
      "&:hover": {
        backgroundColor: PALETTE_VARS.action.hover
      },
      "&.Mui-focusVisible": {
        outline: `2px solid ${PALETTE_VARS.primary.main}`
      }
    };
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== content || $[19] !== link.href || $[20] !== link.onClick) {
    t10 = <ButtonBase disableRipple={true} component={Link} to={link.href} onClick={link.onClick} sx={t9}>{content}</ButtonBase>;
    $[18] = content;
    $[19] = link.href;
    $[20] = link.onClick;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}